import { MenuList as MenuListEl, MenuButton as MenuButtonEl } from '@reach/menu-button'
import styled from 'styled-components'
import { rem } from 'polished'

export const Button = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid currentColor;
  height: 1rem;
  width: 1rem;
  border-radius: 0.5rem;
  transition: all 0.3s ease-in-out;

  svg {
    transition: all 0.3s ease-in-out;
    height: ${rem(8)};
    width: ${rem(8)};
  }

  &:hover {
    background: white;

    svg {
      fill: ${p => p.theme.rolex.colors.primary};
    }
  }
`

export const Tip = styled.span`
  content: '';
  height: 0.5rem;
  width: 0.5rem;
  background: ${p => p.theme.rolex.colors.shades[100]};
  transform: translateX(-50%) rotate(45deg);
  position: absolute;
  pointer-events: none;
  opacity: 0;
  margin-top: 0.25rem;
`

export const MenuButton = styled(MenuButtonEl)`
  outline: none;
  &[aria-expanded='true'] {
    ${Tip} {
      opacity: 1;
    }
  }
`

export const MenuList = styled(MenuListEl)`
  transform: translateX(-5rem);
  outline: none;
  position: relative;
  max-width: 25rem;
  width: 100%;
  padding: 1rem;
  background: #f6f6f6;
  margin-top: 0.5rem;
  border-radius: 0.25rem;
  z-index: 2;
`
